import { CardInfoDto } from "./card-info.dto";

export class SponsoredCardDto{
    /*
    * 
    */
   constructor(
    public id?: number,
    public displaySorting?: number,
    public active?: boolean,
    public startDateSponsorship?: string,
    public endDateSponsorship?: string,
    public photo?: string,
    public link?: string,
   ){}
}